'use strict';

var Nav = function(config) {
  var self = this;
  var $el = $(config.el);
  var $li = $el.find('li');

  self.wrapEl = function() {
    $el.wrap(config.container);
    self.appendButton();
  }

  self.appendButton = function() {
    var $container = $(config.containerEl);
    var $button = $(config.button);
    $container.prepend($button);

    self.clickHandler($button);
  }

  self.clickHandler = function($button) {
    $button.on('click', function() {
      self.elVisibility($button);
    });
  }

  self.elVisibility = function($button) {
    if ($el.hasClass('is-visible') && !$el.hasClass('velocity-animating')) {
      self.hideEl($button);
    } else if (!$el.hasClass('velocity-animating')) {
      self.showEl($button);
    }
  }

  self.hideEl = function($button) {
    $button.removeClass('is-active');
    $el
      .removeClass('is-visible')
      .velocity(
        'slideUp', {
          easing: 'easeOutQuart'
        }
      );
    $li
      .velocity({
        opacity: 0
      });
  }

  self.showEl = function($button) {
    $button.addClass('is-active');
    $el
      .addClass('is-visible')
      .velocity(
        'slideDown', {
          easing: 'easeOutQuart'
        }
      );
    $li.each(function(i) {
      var $this = $(this);
      $this
        .velocity({
          opacity: 1
        }, {
          delay: 100 * i
        });
    });
  }

  self.destroy = function() {
    $el
      .removeClass('is-visible')
      .removeAttr('style');
    $li.removeAttr('style');
  }

  self.init = function() {
    self.wrapEl();
  }
};

module.exports = Nav;
